"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDeferredQueueTableColumns = function (resources) { return [
    {
        dataField: 'serialNumber',
        text: resources.Pack,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '30%'
        }
    }, {
        dataField: 'submissionTime',
        text: resources.SubmissionTime,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '30%'
        }
    }, {
        dataField: 'action',
        text: resources.Action,
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '15%'
        }
    }
]; };
//# sourceMappingURL=DeferredQueueTableColumns.js.map